import styled from 'styled-components'
export const ProfileWrapper = styled.div`
  /* padding-top: 20px; */
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  h1 {
    font-family: 'Inter';
    font-style: normal;
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSize.xl};
    line-height: 140%;
    color: ${({ theme }) => theme.colors.navyBlue};
  }
  p {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSize.x3};
    color: ${({ theme }) => theme.colors.navyBlue};
    opacity: 0.8;
    margin-top: -1px;
  }
  span {
    font-style: normal;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.profileBlack};
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSize.x7};
    line-height: 140%;
    margin-top: -7px;
  }
  .box {
    background: ${({ theme }) => theme.colors.white};
    margin-bottom: 20px;
    padding-left: 16px;
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #cdd2fd;
    border-radius: 10px;
  }
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
    margin-top: 20px;
  }
  .cards {
    overflow-y: scroll;
    height: 100%;
    margin-top: 2rem;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
      display: none;
    }
  }
`
